import { render, staticRenderFns } from "./SideBarOrganizationHelicopter.vue?vue&type=template&id=4bb72ea6&"
import script from "./SideBarOrganizationHelicopter.vue?vue&type=script&lang=js&"
export * from "./SideBarOrganizationHelicopter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports